var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.child
    ? _c(
        "a",
        {
          staticClass: "button-link",
          attrs: { href: _vm.href },
          on: {
            click: function($event) {
              return _vm.$emit("click", $event)
            },
            mouseenter: function($event) {
              _vm.animate = true
            },
            mouseleave: function($event) {
              _vm.animate = false
            }
          }
        },
        [
          _c(
            "span",
            { staticClass: "d-inline-block position-relative" },
            [
              _vm._t("default"),
              _vm._v(" "),
              _c("span", {
                staticClass: "nav__arrow-icon icon-arrow",
                class: _vm.iconClasses
              })
            ],
            2
          )
        ]
      )
    : _c(
        "button",
        {
          staticClass: "button-link",
          on: {
            click: function($event) {
              return _vm.$emit("click", $event)
            },
            mouseenter: function($event) {
              _vm.animate = true
            },
            mouseleave: function($event) {
              _vm.animate = false
            }
          }
        },
        [
          _c("span", { staticClass: "d-inline-block position-relative" }, [
            _c("span", { staticClass: "text" }, [_vm._t("default")], 2),
            _vm._v(" "),
            _c("span", {
              staticClass: "nav__arrow-icon icon-arrow",
              class: _vm.iconClasses
            })
          ])
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }